import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { BsMic, BsMicMute } from "react-icons/bs";
import img from "../../assets/livestream_photo.jpeg";

function MeetingParticipantCard({ name, muted, active, id }) {
  return (
    <Flex
      key={id}
      position={"relative"}
      borderRadius="10px"
      border={active ? "4px solid #50BB69" : "unset"}
      boxShadow="1px 1px 10px #00000073"
      h="100px"
      maxH="100px"
      maxW="150px"
      w="150px"
      minW={"150px"}
      overflow={"hidden"}
      className=" animate__animated animate__bounceInLeft animate__faster"
    >
      <Box
        w="100%"
        h="100%"
        position={"absolute"}
        bg="#00000030"
        zIndex={"1"}
      />
      <Image
        src={img}
        alt="meeting-participant"
        w="100%"
        h="150px"
        objectFit={"cover"}
        position="absolute"
        zIndex={"0"}
      />

      <Flex
        flexDirection={"row"}
        alignItems="center"
        position={"absolute"}
        bottom="5px"
        zIndex={"3"}
        justifyContent="space-between"
        w="100%"
        px="10px"
      >
        <Flex
          borderRadius={"50%"}
          w="20px"
          h="20px"
          bg="#FAFAFA"
          alignItems={"center"}
          justifyContent="center"
        >
          {muted ? (
            <BsMicMute fontSize={".9em"} color="#000" />
          ) : (
            <BsMic fontSize={".9em"} color="#000" />
          )}
        </Flex>
        <Text color="#fff" fontSize={".8em"}>
          {name}
        </Text>
      </Flex>
    </Flex>
  );
}

export default MeetingParticipantCard;
